import { render, staticRenderFns } from "./file-select.vue?vue&type=template&id=480081d1&scoped=true&"
import script from "./file-select.vue?vue&type=script&lang=ts&"
export * from "./file-select.vue?vue&type=script&lang=ts&"
import style0 from "./file-select.vue?vue&type=style&index=0&id=480081d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480081d1",
  null
  
)

export default component.exports